"use strict";

function _classCallCheck(e, r) {
  if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var a = r[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), e;
}
var className1 = function () {
  return _createClass(function e(r, t, a) {
    _classCallCheck(this, e), this.principal = r, this.years = t, this.rate = a;
  }, [{
    key: "getMonthlyPayment",
    value: function () {
      var e = this.rate / 100 / 12;
      return this.principal * e / (1 - Math.pow(1 / (1 + e), 12 * this.years));
    }
  }, {
    key: "getAmortization",
    value: function () {
      for (var e = this.monthlyPayment, r = this.rate / 100 / 12, t = this.principal, a = [], n = 0; n < this.years; n++) {
        for (var i = 0, s = 0, c = 0; c < 12; c++) {
          var l = t * r,
            o = e - l;
          i += l, s += o, t -= o;
        }
        a.push({
          principalY: s,
          interestY: i,
          balance: t
        });
      }
      return a;
    }
  }, {
    key: "getUniqueId4Property",
    value: function (e, r) {
      var t = r;
      return t = t ? (t = (t = r.replace(/, USA/g, "").trim().replace(/,/g, "")).replace(/  /g, " ")).replace(/ /g, "-") : "DUMMYADDRESS", "".concat(e, "-").concat(t);
    }
  }]);
}();
module.exports = {
  CriticalElementsHelper: className1
};